import {Alert} from "antd";
import React, {FC} from "react";

/**
 * Hinweis auf Buchungsseiten, deren Person per DSGVO-Löschantrag gelöscht wurde: die Belege stehen
 * eingeschränkt, der Server lehnt jede Weiterverarbeitung ab (ADR 0014).
 */
const ErasedRecordNotice: FC<{erasedAt?: string | null}> = ({erasedAt}) =>
    erasedAt ? (
        <Alert
            data-testid="erased-record-notice"
            type="warning"
            showIcon
            style={{marginBottom: 16}}
            message="Die Daten dieser Person wurden auf Antrag gelöscht (DSGVO). Die Buchung bleibt als Beleg eingeschränkt erhalten: Storno, Umbuchung, Rechnungskorrektur sowie Änderungen an Raten, Rabatten und Zahlungsart lehnt das System ab. Zahlungseingänge lassen sich weiter erfassen."
        />
    ) : null;

export default ErasedRecordNotice;
